import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import * as _ from 'lodash';
import {AppService} from 'src/app/app.service';
import {EntityService} from 'src/app/_core/entity.service';
import {DialogsService} from 'src/app/_services/dialogs.service';
import {routerTransition} from 'src/app/_core/static/animations';
import {AuthService} from "../../_core/auth.service";
import {OrderService} from "../../_services/order.service";
import {MatSidenav} from "@angular/material/sidenav";
import {InAppService, TabitWrapperPermissionStatus} from "../../_core/inapp.service";
import {firstValueFrom} from "rxjs";

declare const $: any;


@Component({
    selector: 'app-info-page',
    templateUrl: './info-page.component.html',
    styleUrls: ['./info-page.component.scss'],
    host: {
        'class': 'host-default',
        '[@routerTransition]': '',
    },
    animations: [
        routerTransition
    ],
    standalone: false
})
export class InfoPageComponent implements OnDestroy, OnInit {
	@ViewChild('appSidenav', { static: false }) public appSidenav: MatSidenav;
	message: any = null;
	mode= 'tabitPay';
	loading = false;
	animationInterval;

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
		public orderService: OrderService,
		public inAppService: InAppService,
		private router: Router,
		private route: ActivatedRoute,
	) {
		const params = this.appService.urlParams;
		if (!params.oid && this.appService.regionArgs.enableApp == true) {
			this.mode = 'inApp';
			sessionStorage.removeItem('site');
			if (this.appService.user) this.initLoggedIn();
		} else {
			if (params.oid) {

			}
		}
	}

	ngOnInit() {
		let message = this.router.lastSuccessfulNavigation?.extras?.state?.data?.message;
		if (message) {
			this.message = {
				//animation: 'emptyBox',
				text: message
			}
			this.appService.alert({html: this.appService.translate(message)});
			delete this.router.lastSuccessfulNavigation?.extras.state.data.message;
		}
	}

	ngOnDestroy() {
		clearInterval(this.animationInterval);
	}


	async loadFromScanURL(sURL?: string) {
		this.orderService.initFromURL(sURL);
	}

	handleOpenQRScanner(): void {
		firstValueFrom(this.inAppService.openQrScanner()).then(result => {
			if (result.status == TabitWrapperPermissionStatus.AUTHORIZED && result.data) {
				//location.href = location.href;
				//this.appService.toastr(JSON.stringify(result.data))
				this.loadFromScanURL(result.data);
			}
		});
	}

	onSideNvaAction($event: any) {
		switch ($event) {
			case 'signout': this.logout(); break;
			case 'signin': this.login(); break;
			case 'wallet': this.dialogsService.showWallet(); break;
		}
	}
	toggleAppSidenav() {
		this.appSidenav.toggle();
	}

	//---------------------------------------------------------------------------------------->

	login() {
		this.dialogsService.login(null, 'infoPage').then(data => {
			if (this.mode == 'inApp' && this.appService.user) {this.initLoggedIn();}
		})
	}

	logout() {
		return this.appService.confirm({ content: 'MESSAGES.CONFIRM_SIGNOUT' }).then((res) => {
			this.appService.startBlock();
			this.authService.signOut().then(() => {
				this.history = null;
			}).finally(() => {
				this.appService.stopBlock();
			})
		}).catch(err => { });
	}

	history;
	initLoggedIn() {
		this.loading = true;
		this.entityService.getUserHistory().then(response => {
			if (!response[0]) return;
			let sites = [], grouped = _.groupBy(response, o => { return o.organization })
			_.each(grouped, (val: any, key) => {
				let site = val[0];
				sites.push(site);
			});

			const pageSize = 3;
			this.history = {
				sites: sites,
				orders: response,
				max: response.length,
				page: 0,
				pageSize,
			}
			this.setOrdersPage();
		}).catch().then(o => {

		}).finally(() => {
			this.loading = false;
		})
	}

	setOrdersPage(op = 0) {
		let history = this.history;
		let page = history.page + op;
		const start = page * history.pageSize;
		const end = Math.min(start + history.pageSize, history.max);
		history.page = page;
		history.start = start;
		history.end = end;
		history.hasNext = history.end < history.max;

		let orders = this.history.orders.slice(start, end);
		orders.forEach((order) => {
			if (order._offers || order._loading) return;
			order._loading = true;
			this.entityService.get(`/online-shopper/orders/${order.order}?anywhere=true`,null, { 'ros-organization': order.organization }).then(response => {
				const offers = response.orderedOffers;
				if (offers.length > 0) {
					let _offers = order._offers = [];
					order.real = response;
					offers.forEach((offer) => {
						let found = _offers.find(o => o.name === offer.name);
						if (found) {
							found.count += 1;
						} else {
							_offers.push({name: offer.name, count: 1})
						}
					});
					order._active = true;
				} else {
					let index = this.history.orders.indexOf(order);
					this.history.orders.splice(index, 1);
					this.setOrdersPage(0);
				}
			}).catch(err => {
				//debugger
			}).finally(() => {
				order._loading = false;
			});
		});
		if (page > 0) {
			setTimeout(() => {
				let objDiv = document.getElementsByClassName("module-content")[0];
				objDiv.scrollTop = objDiv.scrollHeight;
			})
		}
	}


	/*gotoSite(siteId, order?) {
		let urlParams = this.appService.urlParams;
		urlParams.site = siteId;
		sessionStorage.setItem('site', siteId);
		const navigationExtras: NavigationExtras = { state: { data: { hasBack: true, fromSplash: true } } };
		this.router.navigate(['/orderin'], navigationExtras);

		/!*let resultURL = `${document.location.origin}/?site=${params.site}&oid=${params.oid}`;
		document.location.replace(resultURL);*!/
	}*/

	historyClick(order, ev) {
		if (!order._active) return;
		let actions = [
			{ id: 'viewReceipt', text: 'view_bill', icon: 'receipt', active: true },
			{ id: 'reOrder', text: 'TO.reorder', icon: 'refresh', active: true },
		].filter(act => act.active);
		this.dialogsService.openBottomSheet({ actions: actions }).then(response => {
			if (response) {
				switch (response["id"]) {
					case "viewReceipt":
						this.dialogsService.toggleActionFrame('bill', order, ev);
						break;
					case "reOrder":
						this.appService.$routeStorage = order.real
						this.gotoSite(order.organization, order.real)
					break;
				}
			}
		});
	}

	///

	gotoSite(siteId, order?) {

		let urlParams = this.appService.urlParams;
		urlParams.site = siteId;

		this.appService.startBlock({ class: 'dark-block' });
		this.orderService.clearOrder();
		this.orderService.initTabitOrder(null, order).then((res) => {
			let $storage = this.orderService.$storage;
			$storage._restored = true;
			$storage.hasBack = true;
			sessionStorage.setItem('site', siteId);
			this.router.navigate(['/orderin']);
		}).catch(err => {
			console.error('ERROR', err);
			if (err?.type != 'CANCELED') {
				this.appService.alert({html: this.appService.translate(err?.log  || 'TD.service_unavailable')});
			}
		}).finally(() => {
			this.appService.stopBlock();
		});
	}


}
